import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TariffStore } from '../../../../tariff';

import { debounceTime, fromEvent } from 'rxjs';
import { PlatformService, WINDOW } from '@seven1/angular/ssr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-scroll-to-table',
    imports: [CommonModule, MatIconModule],
    templateUrl: './scroll-to-table.component.html',
    styleUrl: './scroll-to-table.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'px-5 bg-white' }
})
export class ScrollToTableComponent {
  public tariffStore: TariffStore = inject(TariffStore);
  private _window = inject(WINDOW);
  private _platform = inject(PlatformService);
  private _document = inject(DOCUMENT);
  private targetSelector = '.app-tariff-table-scroll-link';
  private activationPoint = 0;
  private yOffset = -100;
  private turnOffOffset = 1500;
  public active = signal(false);

  constructor() {
      if (this._platform.isBrowser) {
          // @ts-expect-error window has events if present
          fromEvent(this._window, 'scroll')
              .pipe(
                  debounceTime(200),
                  takeUntilDestroyed()
              )
              .subscribe(() => {
                  const elements = this._document.querySelectorAll(
                      this.targetSelector,
                  );
                  if (elements && this._window) {
                      for (let i = 0; i < elements.length; i++) {
                          if (
                              getComputedStyle(elements[i]).getPropertyValue('display') !==
                              'none'
                          ) {
                              this.activationPoint =
                                  elements[i].getBoundingClientRect().top - this.yOffset;
                              if (
                                  this.activationPoint < 0 &&
                                  this._document.body.scrollHeight -
                                  (this._window.scrollY +
                                      this._window.innerHeight) -
                                  this.turnOffOffset >
                                  0
                              ) {
                                  this.active.set(true);
                              } else {
                                  this.active.set(false);
                              }
                          }
                      }
                  }
              });
      }
  }

  public scrollToFragment() {
    const elements = this._document.querySelectorAll(
      this.targetSelector,
    );
    if (elements) {
      for (let i = 0; i < elements.length; i++) {
        if (
          getComputedStyle(elements[i]).getPropertyValue('display') !== 'none'
        ) {
          const yPosition =
            elements[i].getBoundingClientRect().top +
            window.scrollY +
            this.yOffset;
          window.scrollTo({ top: yPosition, behavior: 'smooth' });
        }
      }
    }
  }
}
